import palette from './palette';

export const numberBox = {
  backgroundColor: 'primary.main',
  borderRadius: 0.5,
  color: 'common.white',
  display: 'inline-block',
  width: '20px',
  height: '20px',
  lineHeight: '20px',
  marginRight: 1,
  fontSize: '14px'
};

export const infoBoxStyles = {
  display: 'flex',
  gap: 1,
  padding: 2,
  marginY: 1,
  border: 1,
  borderColor: palette.border,
  borderRadius: 2,
  backgroundColor: palette.info.screen
};

export const warningBoxStyles = {
  display: 'flex',
  gap: 1,
  padding: 2,
  marginY: 1,
  border: 1,
  borderColor: palette.warning.dark,
  borderRadius: 2
};
